import { render, staticRenderFns } from "./admin-client-token.vue?vue&type=template&id=875596ea"
import script from "./admin-client-token.vue?vue&type=script&lang=js"
export * from "./admin-client-token.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports